import { CardWithBorder } from 'src/components/CardWithBorder';
import { SelectBox } from 'src/components/SelectBox';
import { primaryTimezoneOptions } from './constants';
import { useContactWindow } from './ContactWindowContext';

export const TimezoneSettings = () => {
  const { primaryTz, setPrimaryTz, timezoneError } = useContactWindow();
  return (
    <CardWithBorder>
      <h3 className="mb-2">Timezone</h3>
      <p className="text-sm text-neutral-500 mb-4">
        Determine which timezone to use when scheduling outreach
      </p>
      <div className="flex flex-col gap-4">
        <div className="sm:w-1/2">
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            Primary
          </label>
          <SelectBox
            options={primaryTimezoneOptions}
            value={primaryTz}
            onChange={(v) => {
              const option = primaryTimezoneOptions.find((o) => o.value === v);
              if (option) setPrimaryTz(option);
            }}
          />
          {timezoneError && (
            <div className="mt-2 text-sm text-error-600">{timezoneError}</div>
          )}
        </div>
      </div>
    </CardWithBorder>
  );
};

export default TimezoneSettings;
